// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-player-container{background-color:#333;display:flex;justify-content:center;align-items:center;height:100vh}#player-container{width:100%;height:100%}::-webkit-scrollbar{display:none}.vd-intro{display:none}", ""]);
// Exports
module.exports = exports;
